import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  KeyboardView,
  Wrapper,
  Title,
  Copy,
  Row,
  Button,
  Card
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import {
  /*mobile*/
  appRedirect,
  setPaymentPage,
  setDemoPage,
  toggleDemoPage,
  loadSignUpOnboarding
} from "app/NativeActions";

import SelectedEngines from "./SelectedEngines";
import Engines from "./Engines";

class SelectPlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_engine_tab:
        props.user_info && props.user_info.signup_engine
          ? props.user_info.signup_engine
          : "driving",
      selected_frequency:
        props.user_info && props.user_info.signup_frequency
          ? props.user_info.signup_frequency
          : props.user_info &&
            props.user_info.signup_engine &&
            props.user_info.signup_engine == "messages"
          ? "monthly"
          : "annually",
      selected_engines:
        props.user_info && props.user_info.signup_engine
          ? [
              {
                engine: props.user_info.signup_engine,
                tier: props.user_info.signup_tier || 2,
                frequency: props.user_info.signup_frequency || "annually"
              }
            ]
          : [],

      onboarding_content: null,
      onboarding_content_loading: true
    };

    this.selectEngine = this.selectEngine.bind(this);
    this.selectEngineTab = this.selectEngineTab.bind(this);
    this.onFrequencySwitch = this.onFrequencySwitch.bind(this);
  }

  componentDidMount() {
    this.getOnboardingData();
  }

  getOnboardingData() {
    loadSignUpOnboarding("new_onboarding")
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState(() => ({
            onboarding_content: data.items[0]
              ? data.items[0].fields
                ? data.items[0].fields
                : null
              : null,
            onboarding_content_loading: false
          }));
        }
        this.setState(() => ({ onboarding_content_loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ onboarding_content_loading: false }));
      });
  }

  componentDidUpdate(prevProps) {}

  selectEngine(engine) {
    if (engine) {
      this.setState({
        selected_engines: [
          {
            engine: engine.engine,
            tier: engine.tier,
            frequency: engine.frequency
          }
        ],
        selected_frequency:
          engine.engine == "messages"
            ? "monthly"
            : this.state.selected_frequency
      });
    } else {
      this.setState({
        selected_engines: []
      });
    }
  }

  selectEngineTab(selected_engine_tab) {
    this.setState({
      selected_engine_tab,
      selected_frequency:
        selected_engine_tab == "messages"
          ? "monthly"
          : this.state.selected_frequency
    });
  }

  onFrequencySwitch(selected_frequency) {
    this.setState({
      selected_frequency
    });
  }

  render() {
    const { selected_engines, onboarding_content } = this.state;
    if (onboarding_content) {
      return (
        <Container fill>
          <Wrapper
            style={{
              alignItems: "center",
              justifyContent: "flex-start",
              flex: 1
            }}
          >
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                maxWidth: 750
              }}
            >
              <Wrapper
                style={{
                  paddingTop: this.props.isMobile ? 60 : 40,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Copy style={{ textAlign: "center" }}>Step 4 of 5</Copy>
              </Wrapper>
              <Wrapper
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 40
                }}
              >
                <Title style={{ textAlign: "center", marginBottom: 10 }}>
                  {selected_engines.length > 0
                    ? onboarding_content.confirmPlansTitle
                    : onboarding_content.selectPlansTitle}
                </Title>
                <Copy>
                  {selected_engines.length > 0
                    ? onboarding_content.confirmPlansDescription
                    : onboarding_content.selectPlansDescription}
                </Copy>
              </Wrapper>
            </Wrapper>
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "flex-start",
                alignSelf: "stretch",
                flex: 1
              }}
            >
              <SelectedEngines
                {...this.props}
                clearEngines={this.selectEngine}
                selected_engines={selected_engines}
                selected_frequency={this.state.selected_frequency}
              />

              {selected_engines.length == 0 ? (
                <Engines
                  selected_engine={this.state.selected_engine_tab}
                  selectEngineTab={this.selectEngineTab}
                  onEngineSelect={this.selectEngine}
                  onDemoPress={demo => {
                    this.props.setDemoPage({
                      title: demo.title,
                      webinar_id: demo.webinar_id
                    });
                    this.props.toggleDemoPage(true);
                  }}
                  include_annual_toggle={
                    this.state.selected_engine_tab == "messages" ? false : true
                  }
                  onFrequencySwitch={this.onFrequencySwitch}
                  selected_frequency={this.state.selected_frequency}
                />
              ) : null}
            </Wrapper>
          </Wrapper>
        </Container>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth, marketing, native, settings, billing }) => {
  const { token, user } = auth;

  const { user_info, partner_info } = marketing;
  const { colors } = settings;
  const { device, isMobile } = native;
  const { card } = billing;
  return {
    token,
    user,
    device,
    isMobile,
    user_info,
    partner_info,
    card,
    colors
  };
};

export default connect(mapStateToProps, {
  /*mobile*/
  appRedirect,
  setPaymentPage,
  setDemoPage,
  toggleDemoPage
})(SelectPlans);
